import { APIProvider } from '@vis.gl/react-google-maps';
import { type FC, type ReactNode } from 'react';
import { DefaultGooglePlacesApi } from './DefaultGooglePlacesApi';
import { GooglePlacesContext } from './GooglePlacesContext';

interface Props {
  readonly apiKey: string;
  readonly children: ReactNode;
}

export const GooglePlacesProvider: FC<Props> = ({ apiKey, children }) => {
  const googlePlaces = new DefaultGooglePlacesApi();
  return (
    <APIProvider apiKey={apiKey} libraries={['places']}>
      <GooglePlacesContext.Provider value={googlePlaces}>{children}</GooglePlacesContext.Provider>
    </APIProvider>
  );
};
